export const kintzAppColors = {
  primary_1: '#161616',
  primary_2: "#0283C7",
  primary_3: '#494949',
  primary_4: '#D1D2D4',
  secondary_1: '#DB1120',
  secondary_2: '#00AEEF',
  secondary_3: '#42AD49'
}
